import { useGlobalState } from '@/hooks';
import { getShipments } from '@/modules/pmt/fetchers';
import { gtmInvalidParcelSearches } from '@/utils';
import { useEffect, useState } from 'react';
import { getGaClientId, getSessionId } from '../utils/ga4.utils';

const useFetchShipments = () => {
  const { pmtCurrentLanguageCode, firestoreUuid, isLoggedIn, isMyParcelsPage } = useGlobalState();
  const [parcelIds, setParcelIds] = useState<string[]>([]);

  useEffect(() => {
    if (!parcelIds.length || !firestoreUuid) return;
    // TODO: FE has to use Promise.all() to call search shipments concurrently,
    // but BE should support plural parcelIds
    (async () => {
      const searchPromises = parcelIds.map(async (parcelId) => {
        return getShipments({
          uuid: firestoreUuid,
          parcelId,
          language: pmtCurrentLanguageCode,
          isLoggedIn,
          gaClientId: getGaClientId(),
          gaSessionId: getSessionId(isMyParcelsPage),
          eventTimestamp: Date.now().toString(),
        });
      });

      try {
        const statuses = await Promise.all(searchPromises);
        statuses.forEach((result) => {
          if (result?.status === 400) {
            gtmInvalidParcelSearches();
          }
        });
      } catch (err) {
        console.error(err);
      }
    })();
    setParcelIds([]);
  }, [firestoreUuid, parcelIds, pmtCurrentLanguageCode, isLoggedIn]);

  return { fetchShipments: setParcelIds };
};

export { useFetchShipments };
